const root = 'batchActionsBar'

export const TestId = {
  root,
  selectedNumberLabel: `${root}-selectedNumberLabel`,
  action: actionName => `${root}-action-${actionName}`,
}
